import { Client } from "./client";
import { PartDutAssignmentsResponse, GetAllPartDutAssignmentsResponse, CreatePartDutAssignmentsRequest } from "@/backend/express/controllers/partDutAssignmentsController";
import { FusaReply } from "@/types/replyTypes";

export class PartDutAssignmentsFrontendController {
  client: Client;

  constructor() {
    this.client = new Client();
  }

  getPartDutAssignments(id: string): Promise<PartDutAssignmentsResponse> {
    return this.client.read(`/api/part-dut-assignments/${id}`);
  }

  getPartDutAssignmentsByPartId(partId: string): Promise<GetAllPartDutAssignmentsResponse> {
    return this.client.read(`/api/part-dut-assignments/part/${partId}`);
  }

  getPartDutAssignmentsByProcedureInstanceId(procedureInstanceId: string): Promise<GetAllPartDutAssignmentsResponse> {
    return this.client.read(`/api/part-dut-assignments/procedure-instance/${procedureInstanceId}`);
  }

  getPartDutAssignmentsByProcedureInstanceIds(procedureInstanceIds: string[]): Promise<GetAllPartDutAssignmentsResponse> {
    return this.client.create(`/api/part-dut-assignments/procedure-instances`, { procedureInstanceIds });
  }

  async createPartDutAssignments(data: CreatePartDutAssignmentsRequest): Promise<PartDutAssignmentsResponse> {
    return this.client.create('/api/part-dut-assignments', data);
  }

  async deletePartDutAssignments(id: string): Promise<FusaReply> {
    return this.client.delete(`/api/part-dut-assignments/${id}`);
  }
}
